// MUST stay the first import — see the note in bootstrapDiagnostics.
import './bootstrapDiagnostics'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './services/store'
import ErrorBoundary from './components/error-boundary/ErrorBoundary'

// Boot-level listener for firebase-data-message (runs ASAP at app startup)
console.log('[Push] Boot-level listener armed')
window.addEventListener('firebase-data-message', (ev: any) => {
  try {
    console.log('[Push] Raw event received:', ev)
    console.log('[Push] Event detail type:', typeof ev.detail)
    console.log('[Push] Event detail value:', ev.detail)

    // Capacitor's bridge sends a STRING as detail
    const payload = typeof ev.detail === 'string' ? JSON.parse(ev.detail) : ev.detail
    console.log('[Push] received (bridge)', payload)
    // TODO: dispatch to your store / show in-app banner / etc.
  } catch (e) {
    console.warn('[Push] bad payload', ev.detail, e)
  }
})

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
